import { render, staticRenderFns } from "./VcAlert.vue?vue&type=template&id=11a123c8"
import script from "./VcAlert.vue?vue&type=script&lang=js"
export * from "./VcAlert.vue?vue&type=script&lang=js"
import style0 from "./VcAlert.vue?vue&type=style&index=0&id=11a123c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports